function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  justify-content: center;\n  z-index: 1050;\n  background-color: rgba(0, 0, 0, 0.7);\n  overflow-x: hidden;\n  overflow-y: auto;\n\n  &.fade-enter {\n    opacity: 0;\n  }\n  &.fade-enter-active {\n    opacity: 1;\n    transition: opacity 150ms;\n  }\n  &.fade-exit {\n    opacity: 1;\n  }\n  &.fade-exit-active {\n    opacity: 0;\n    transition: opacity 150ms;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CSSTransition } from 'react-transition-group';
var Backdrop = styled.div(_templateObject());

function ModalBackdrop(_ref) {
  var displayed = _ref.displayed,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(CSSTransition, {
    "in": displayed,
    timeout: 300,
    classNames: "fade",
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement(Backdrop, null, children));
}

ModalBackdrop.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  displayed: PropTypes.bool.isRequired
} : {};
export default ModalBackdrop;